import dispatcher from "../dispatcher";
import * as api from "../api"

export function sentRequestResetPassword() {
    dispatcher.dispatch({ type: "SENT_REQUEST_RESET_PASSWORD" })
}

export function resetPassword(token, password) {
    api.resetPassword(token, password, true).then(res =>
        res.data && dispatcher.dispatch({ type: "PASSWORD_UPDATED" })
    )
}

export function setHierarchyNavItems(_data) {
    setTimeout(() =>
        dispatcher.dispatch({ type: "UPDATE_HIERARCHY_NAV_ITEMS", data: _data })
    );
}

export function setRefreshing(_data) {
    dispatcher.dispatch({ type: "UPDATE_REFRESHING", data: _data });
}

export function toggleExpandLeftNav() {
    dispatcher.dispatch({ type: "TOGGLE_EXPAND_LEFT_NAV" })
}

export function getFrontEndSettings(){
    api.getFrontEndSettings().then(res => {
        dispatcher.dispatch({ type: "UPDATE_FRONT_END_SETTINGS", data: res.data })
    })
}